module.exports = __webpack_public_path__ + "img/arrow-prev.77330eaa.svg";